import React from 'react';
import Navbar from '../../components/Navbar2';
import Contact from '../../components/Contact';
import './index.css';

const ExperiencePage = () => {
  return (
    <div className="experience-page">
      <Navbar />

      {/* Hero Section */}
      <div className="exp-hero">
        <div className="exp-hero-overlay" />
        <div className="exp-hero-content">
          <p className="exp-hero-label">Curated Excellence</p>
          <h1 className="exp-hero-title">
            Tailored Services for
            <br />
            Exceptional Living
          </h1>
          <p className="exp-hero-sub">
            Every Luxe Unbounded property offers more than a luxurious stay — it delivers an experience meticulously curated for comfort, convenience, and peace of mind.
          </p>
        </div>
      </div>

      {/* Intro Section */}
      <div className="exp-intro-section">
        <div className="exp-intro-inner">
          <p className="exp-intro-label">Our Services</p>
          <h2 className="exp-intro-title">A Home That Welcomes You Back</h2>
          <p className="exp-intro-text">
            More than a stay, it's a space that feels like your own.
            Thoughtfully designed residences with full kitchens and elegant living spaces - where every journey begins and ends in comfort.
          </p>
        </div>
      </div>

      {/* Services Sections */}
      <div className="exp-sections-wrap">
        {/* Service 1 - Personal Concierge */}
        <div className="exp-hs-section">
          <div className="exp-hs-text">
            <p className="exp-hs-label">Service 01</p>
            <h2 className="exp-hs-title">Your Personal Concierge, Always Close</h2>
            <p className="exp-hs-desc">
              Every home comes with a dedicated Property Manager - your quiet enabler of effortless living.
              From daily comforts to curated local experiences, everything you need is just a call away.
            </p>
          </div>
          <div className="exp-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fpic7.webp?alt=media&token=6d5db0bc-976e-46e7-b5a1-de75e8d1b0c0"
              alt="Concierge"
            />
          </div>
        </div>

        {/* Service 2 - Fully Equipped */}
        <div className="exp-hs-section exp-hs-section-reversed">
          <div className="exp-hs-text">
            <p className="exp-hs-label">Service 02</p>
            <h2 className="exp-hs-title">Fully Equipped for Real Living</h2>
            <p className="exp-hs-desc">
              Cook, unwind, and live at your own pace.
              With fully fitted kitchens, washing facilities, and all essentials in place, you don't adapt to travel - travel adapts to you.
            </p>
          </div>
          <div className="exp-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxe%2FBanner%2FKitchen%20image.jpg?alt=media&token=7bd534d5-aa3a-44b4-9d64-0282f3a14f10"
              alt="Fully Equipped Kitchen"
            />
          </div>
        </div>

        {/* Service 3 - Privacy Secured */}
        <div className="exp-hs-section">
          <div className="exp-hs-text">
            <p className="exp-hs-label">Service 03</p>
            <h2 className="exp-hs-title">Privacy, Secured</h2>
            <p className="exp-hs-desc">
              Set within premium gated communities, each residence offers 24/7 security and a sense of calm that lets you truly switch off and feel at ease.
            </p>
          </div>
          <div className="exp-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fpic-8.webp?alt=media&token=7b755917-98f4-446f-a802-fd14f5fa0fc8"
              alt="Security"
            />
          </div>
        </div>

        {/* Service 4 - Spaces to Gather */}
        <div className="exp-hs-section exp-hs-section-reversed">
          <div className="exp-hs-text">
            <p className="exp-hs-label">Service 04</p>
            <h2 className="exp-hs-title">Spaces to Gather & Belong</h2>
            <p className="exp-hs-desc">
              Beautiful clubhouses and shared spaces invite moments of connection - whether with family, friends, or like-minded travellers.
            </p>
          </div>
          <div className="exp-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxe%2FBanner%2FClub%20House.jpg?alt=media&token=e270819b-3c56-4ab9-a43c-5ea544bb4de0"
              alt="Clubhouse"
            />
          </div>
        </div>

        {/* Service 5 - General Physician */}
        <div className="exp-hs-section">
          <div className="exp-hs-text">
            <p className="exp-hs-label">Service 05</p>
            <h2 className="exp-hs-title">General Physician on Call</h2>
            <p className="exp-hs-desc">
              For your health and well-being, a General Physician is readily available on call. Whether addressing minor health concerns or providing urgent care, our dedicated medical professional ensures that expert healthcare is just a phone call away, so you can travel with confidence.
            </p>
          </div>
          <div className="exp-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fpic4.webp?alt=media&token=db2ddcac-f9c8-4285-b4cc-6d7fe32d47aa"
              alt="Physician"
            />
          </div>
        </div>

        {/* Service 6 - Dining Your Way */}
        <div className="exp-hs-section exp-hs-section-reversed">
          <div className="exp-hs-text">
            <p className="exp-hs-label">Service 06</p>
            <h2 className="exp-hs-title">Dining, Your Way</h2>
            <p className="exp-hs-desc">
              From intimate meals in your own kitchen to vibrant community dining spaces, every experience is designed around choice, comfort, and togetherness.
            </p>
          </div>
          <div className="exp-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxe%2FBanner%2FLast%20image.jpg?alt=media&token=d4f70a97-5bb5-4313-bbf0-6f1c82836bee"
              alt="Dining"
            />
          </div>
        </div>
      </div>

      <Contact />
    </div>
  );
};

export default ExperiencePage;
